import React, {Component} from 'react';

/**
 * @param {Function<Component>} ComposedComponent
 * @param {String} mediaQuery
 * @param {Boolean} [defaultMatches=false]
 * @return {Function<Component>}
 * @constructor
 */
export function MatchMediaHOC(ComposedComponent, mediaQuery, defaultMatches = false) {
  return class MatchMediaHOCComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {mediaQuery: defaultMatches};
      this.mql = null;
      this.onMatch = this.onMatch.bind(this);
    }

    componentDidMount() {
      if (!window.matchMedia) return;

      this.mql = window.matchMedia(mediaQuery);
      this.mql.addListener(this.onMatch);
      this.onMatch(this.mql);
    }

    componentWillUnmount() {
      this.mql && this.mql.removeListener(this.onMatch);
      this.mql = null;
    }

    onMatch(mql) {
      this.setState({mediaQuery: mql.matches});
    }

    render() {
      return <ComposedComponent {...this.props} mediaQuery={this.state.mediaQuery} />;
    }
  };
}

MatchMediaHOC.propTypes = {};

export default MatchMediaHOC;



// WEBPACK FOOTER //
// ./src/js/_libs/react-rx-match-media/src/MatchMediaHOC.js